import React from 'react';
import PropTypes from 'prop-types';
import {Box, Flex, Heading, Text} from 'rebass'
import {Tabs} from 'reakit'
import {ActiveTabCircle, InactiveTabCircle, Sidebar, TabWrapper, Wrapper} from './styles'
import {LeaveTransportationForm, LeaveTypeForm, LocationForm, StudentForm, FacultyForm, ParentForm} from "../../components/Forms";
import PopupForm from '../../components/Modals/PopupForm'

import ConfigTabPanel from './ConfigTabPanel'
import ConfigMemberPanel from './ConfigMemberPanel'

const ConfigurationsPanel = (props) => {  
	const {
		handleSubmitLeaveType, handleSubmitTransport, handleSubmitLocation, handleSubmitParent,
		handleUpdateLeaveType, handleUpdateTransport, handleUpdateLocation, handleUpdateStudent, handleUpdateFaculty, handleUpdateParent,
		leaveTypes, locations, transportation, students, faculties, parents
	} = props;
	const renderAddNew = (tab) => {
		if (tab === 0) {
			return (
				<PopupForm
					FormComponent={LeaveTypeForm}
					handleSubmit={handleSubmitLeaveType}
				/>
			)
		}
		if (tab === 1){
			return (
				<PopupForm
					FormComponent={LeaveTransportationForm}
					handleSubmit={handleSubmitTransport}
					/>
			)
		}
		if (tab === 2){
			return (
				<PopupForm
					FormComponent={LocationForm}
					handleSubmit={handleSubmitLocation}
				/>
			)
		}
		if (tab === 5){
			return (
				<PopupForm
					FormComponent={ParentForm}
					handleSubmit={handleSubmitParent}
				/>
			)
		}
	}

	const renderConfigPanel = (tab) => {
		if (tab === 0) {
			return (
				<ConfigTabPanel
					handleSubmit={handleUpdateLeaveType}
					form={LeaveTypeForm}
					items={leaveTypes}
					title={'Leave Type'}
				/>
			)
		}
		if (tab === 1){
			return (
				<ConfigTabPanel
					handleSubmit={handleUpdateTransport}
					form={LeaveTransportationForm}
					items={transportation}
					title={'Transportation'}
				/>
			)
		}
		if (tab === 2){
			return (
				<ConfigTabPanel
					handleSubmit={handleUpdateLocation}
					form={LocationForm}
					items={locations}
					title={'Locations'}
				/>
			)
		}
		if (tab === 3){
			return ( 
				<ConfigMemberPanel
					handleSubmit={handleUpdateStudent}
					form={StudentForm}
					items={students}
					title={'Students'}
				/>
			)
		}
		if (tab === 4){
			return (
				<ConfigMemberPanel
					handleSubmit={handleUpdateFaculty}
					form={FacultyForm}
					items={faculties}
					title={'Faculties'}
				/>
			)
		}
		if (tab === 5){
			return (
				<ConfigMemberPanel
					handleSubmit={handleUpdateParent}
					form={ParentForm}
					items={parents}
					title={'Hosts'}
				/>
			)
		}
	}

	const renderActiveCount = (items) => {
		if(items){
			const active = items.filter(item => item.activated).length
			const count = items.length
			return (
				<Text color={'meta'}>Active: {active}/{count}</Text>

			)
		} else {
			return (<Text color={'meta'}>No Categories</Text>)
		}
	}

	const renderMemberActiveCount = (items) => {
		if(items){
			const active = items.filter(item => item.activated !== false).length
			const count = items.length
			return (
				<Text color={'meta'}>Active: {active}/{count}</Text>

			)
		} else {
			return (<Text color={'meta'}>No Categories</Text>)
		}
	}

	return (
		<Wrapper>

			<Tabs.Container>
				{(tabs) =>
					(
						<Flex flexDirection={'row'} flexWrap={'wrap'}>

							<Sidebar pt={4}>
								<Tabs boxShadow={'none'}>

									<Flex flexDirection={'column'}>

										{/* Leave Types */}
										<Tabs.Tab tab={'leave-types'} {...tabs}>
											<Flex width={1} pl={'10px'} my={3}>
												<Flex flexWrap={'wrap'} flexDirection={'column'} justifyContent={'center'} px={3}>
													{tabs.current === 0 ? <ActiveTabCircle/> : <InactiveTabCircle/>}
												</Flex>
												<Box pr={3}>
													<Heading lineHeight={0.8} as={'h3'}>Leave Types</Heading>
													{renderActiveCount(leaveTypes)}
												</Box>
											</Flex>
										</Tabs.Tab>

										{/* Transportation */}
										<Tabs.Tab tab={'transportation'} {...tabs}>
											<Flex width={1} pl={'10px'} my={3}>
												<Flex flexWrap={'wrap'} flexDirection={'column'} justifyContent={'center'} px={3}>
													{tabs.current === 1 ? <ActiveTabCircle/> : <InactiveTabCircle/>}
												</Flex>
												<Box pr={3}>
													<Heading lineHeight={0.8} as={'h3'}>Transportation</Heading>
													{renderActiveCount(transportation)}
												</Box>
											</Flex>
										</Tabs.Tab>

										{/*	Locations*/}
										<Tabs.Tab tab={'locations'} {...tabs}>
											<Flex width={1} pl={'10px'} my={3}>
												<Flex flexWrap={'wrap'} flexDirection={'column'} justifyContent={'center'} px={3}>
													{tabs.current === 2 ? <ActiveTabCircle/> : <InactiveTabCircle/>}
												</Flex>
												<Box pr={3}>
													<Heading lineHeight={0.8} as={'h3'}>Locations</Heading>
													{renderActiveCount(locations)}
												</Box>
											</Flex>
										</Tabs.Tab>

										{/*	Students */}
										<Tabs.Tab tab={'Students'} {...tabs}>
											<Flex width={1} pl={'10px'} my={3}>
												<Flex flexWrap={'wrap'} flexDirection={'column'} justifyContent={'center'} px={3}>
													{tabs.current === 3 ? <ActiveTabCircle/> : <InactiveTabCircle/>}
												</Flex>
												<Box pr={3}>
													<Heading lineHeight={0.8} as={'h3'}>Students</Heading>
													{renderMemberActiveCount(students)}
												</Box>
											</Flex>
										</Tabs.Tab>

										{/*	Faculties */}
										<Tabs.Tab tab={'Faculties'} {...tabs}>
											<Flex width={1} pl={'10px'} my={3}>
												<Flex flexWrap={'wrap'} flexDirection={'column'} justifyContent={'center'} px={3}>
													{tabs.current === 4 ? <ActiveTabCircle/> : <InactiveTabCircle/>}
												</Flex>
												<Box pr={3}>
													<Heading lineHeight={0.8} as={'h3'}>Faculty</Heading>
													{renderMemberActiveCount(faculties)}
												</Box>
											</Flex>
										</Tabs.Tab>

										{/*	Parents */}
										<Tabs.Tab tab={'Hosts'} {...tabs}>
										<Flex width={1} pl={'10px'} my={3}>
											<Flex flexWrap={'wrap'} flexDirection={'column'} justifyContent={'center'} px={3}>
												{tabs.current === 5 ? <ActiveTabCircle/> : <InactiveTabCircle/>}
											</Flex>
											<Box pr={3}>
												<Heading lineHeight={0.8} as={'h3'}>Hosts</Heading>
												{renderMemberActiveCount(parents)}
											</Box>
										</Flex>
										</Tabs.Tab>
									</Flex>

								</Tabs>
							</Sidebar>


							<TabWrapper>
								<Box width={1} p={3}>
									{renderAddNew(tabs.current)}
								</Box>


								{renderConfigPanel(tabs.current)}

							</TabWrapper>

						</Flex>
					)}
			</Tabs.Container>
		</Wrapper>
	);
};

ConfigurationsPanel.propTypes = {
	handleSubmitLeaveType: PropTypes.func,
	handleSubmitTransport: PropTypes.func,
	handleSubmitLocation: PropTypes.func,
	handleSubmitParent: PropTypes.func,
	handleUpdateLeaveType: PropTypes.func,
	handleUpdateTransport: PropTypes.func,
	handleUpdateLocation: PropTypes.func,
	handleUpdateStudent: PropTypes.func,
	handleUpdateFaculty: PropTypes.func, 
	handleUpdateParent: PropTypes.func, 
	leaveTypes: PropTypes.array,
	transportation: PropTypes.array,
	locations: PropTypes.array,
	students: PropTypes.array,
	faculties: PropTypes.array,
};

ConfigurationsPanel.defaultProps = {
	handleSubmitLeaveType: (values) => console.log(values),
	handleSubmitTransport: (values) => console.log(values),
	handleSubmitLocation: (values) => console.log(values),
	handleSubmitParent: (values) => console.log(values),
	handleUpdateLeaveType: (values) => console.log(values),
	handleUpdateTransport: (values) => console.log(values),
	handleUpdateLocation: (values) => console.log(values),
	handleUpdateStudent: (values) => console.log(values),
	handleUpdateFaculty: (values) => console.log(values),
	handleUpdateParent: (values) => console.log(values),
};


export default ConfigurationsPanel;
